@if (initials(); as letters) {
  {{ letters }}
} @else if (fallbackIcon(); as icon) {
  <mat-icon>{{ icon }}</mat-icon>
}
